var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCateg = function SvgCateg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386 944 c-225 -54 -376 -286 -338 -517 62 -367 512 -513 773 -252 329 330 18 879 -435 769z m219 -39 c312 -81 418 -473 191 -701 -241 -240 -651 -107 -709 230 -50 295 226 546 518 471z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 649 c-4 -6 -3 -15 2 -20 5 -5 122 -8 279 -7 231 3 269 5 269 18 0 13 -38 15 -272 18 -190 2 -274 -1 -278 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 489 c-16 -25 19 -29 221 -27 178 3 209 5 209 18 0 13 -31 15 -212 18 -147 2 -214 -1 -218 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 329 c-16 -24 18 -29 181 -27 142 3 169 5 169 18 0 13 -27 15 -172 18 -118 2 -174 -1 -178 -9z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCateg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/categ.fea4ee3f.svg";
export { ForwardRef as ReactComponent };